<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <template v-if="paso == 1">
                <h2>Selección de carpeta de destino</h2>
                <ul class="actionList">
                    <li v-for="destino in getDestinos" :key="destino.carpeta" class="tipodocumento" @click="configEnvio.carpetaDestino = destino.carpeta; $router.push('/selectreceivers')">
                        <div style="display:flex; align-items: center;">
                            <div class="icono">
                                <img src="@/assets/carpetageneral.png" width="70%" />
                            </div>
                            <p style="margin:0px;">{{ destino.nombre }}</p>
                        </div>
                    </li>
                </ul>
            </template>
            <div style="display:flex;">
                <el-button type="primary" icon="Back" @click="$router.go(-1)" :disabled="leftDisabled" />
                <el-button type="primary" icon="Right" :disabled="rightDisabled"
                    @click="$router.push('/selecttarget')" />
            </div>
        </div>
    </el-col>
</template>

<script>
// import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'

export default {
    name: 'SelectorDestino',
    watch: {
    },
    components: {

    },
    data() {
        return {
            loading: false,
            paso: 1,
            tipoDocumento: '',
            file: [],
            acciones: {},
            working: process.env.VUE_APP_WORKING
        }
    },
    mounted() {
        if(this.working == 'firmas' && this.configEnvio.paginaActual != 'selectreceivers') {
            this.$router.push('/selectreceivers');
        }
        if(this.working == 'firmas' && this.configEnvio.paginaActual == 'selectreceivers') {
            this.configEnvio.paginaActual = '';
            this.$router.push('/selectemit');
        }
        if(this.params.get('destino') && this.configEnvio.paginaActual != 'selectreceivers') {
            this.configEnvio.carpetaDestino = this.params.get('destino'); 
            this.$router.push('/selectreceivers');
        }
    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'params', 'carpetas'
        ]),
        leftDisabled() {
            return false;
        },
        rightDisabled() {
            return true
        },
        getDestinos() {
            if(this.configEnvio.entrada == 'pdf' || this.configEnvio.entrada == 'contenido') {
                return this.carpetas.filter((carpeta) => {return carpeta.type == 'publicacion'});
            }
            return this.carpetas.filter((carpeta) => {return carpeta.type == 'archivo'});
        }
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores'
        ]),
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 25%;
        padding: 0px;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 30px;
                height: 30px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }
}
</style>